const typography = {
  "h1": {
      "fontSize": 28,
      "fontWeight": 600,
      "lineHeight": "36px",
      "letterSpacing": -0.8
  },
  "h2": {
      "fontSize": 20,
      "lineHeight": "27px",
      "fontWeight": 600,
      "letterSpacing": 0.15
  },
  "h3": {
      "fontSize": 16,
      "lineHeight": "20px",
      "fontWeight": 600
  },
  "h4": {
      "fontSize": 14,
      "fontWeight": 600
  },
  "h5": {
      "fontSize": 12,
      "fontWeight": 600
  },
  "h6": {
      "fontSize": 10,
      "fontWeight": 600
  },
  "body1": {
      "fontSize": 16
  },
  "body2": {
      "fontSize": 14
  },
  "subtitle1": {
      "fontSize": 16
  },
  "subtitle2": {
      "fontSize": 14
  },
  "button": {
      "fontSize": 14,
      "lineHeight": "15px",
      "fontWeight": 600,
      "textTransform": "uppercase",
      "letterSpacing": 0.75
  },
  "caption": {
      "fontSize": 11,
      "fontWeight": 600,
      "lineHeight": "15px",
      "letterSpacing": "0.12em"
  }
}

export const getEnhancedTheme = (theme) => ({
  ...theme,
  typography: {
    ...theme.typography,
    ...typography
  }
})
